"use client";

import { c as _c } from "react/compiler-runtime";
import NextGenNavigationHeader from "@/components/nextGen/collections/NextGenNavigationHeader";
import NextGenTokenComponent from "@/components/nextGen/collections/nextgenToken/NextGenToken";
import NextGenTokenOnChain from "@/components/nextGen/collections/NextGenTokenOnChain";
import { useTitle } from "@/contexts/TitleContext";
import type { NextGenCollection, NextGenToken, NextGenTrait } from "@/entities/INextgen";
import styles from "@/styles/Home.module.scss";
import { NextgenCollectionView } from "@/types/enums";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
export default function NextGenTokenPageClient(t0) {
  const $ = _c(24);
  const {
    tokenId,
    token,
    traits,
    tokenCount,
    collection,
    view: initialView
  } = t0;
  const router = useRouter();
  const {
    setTitle
  } = useTitle();
  const [tokenView] = useState(initialView);
  let t1;
  if ($[0] !== collection.name || $[1] !== setTitle || $[2] !== token?.name || $[3] !== tokenId || $[4] !== tokenView) {
    t1 = () => {
      const baseTitle = token?.name ?? `${collection.name} - #${tokenId}`;
      const viewDisplay = tokenView !== NextgenCollectionView.ABOUT ? tokenView : "";
      const title = viewDisplay ? `${baseTitle} | ${viewDisplay}` : baseTitle;
      setTitle(title);
    };
    $[0] = collection.name;
    $[1] = setTitle;
    $[2] = token?.name;
    $[3] = tokenId;
    $[4] = tokenView;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = token?.name;
  let t3;
  if ($[6] !== collection.name || $[7] !== setTitle || $[8] !== t2 || $[9] !== tokenId || $[10] !== tokenView) {
    t3 = [tokenView, t2, collection.name, tokenId, setTitle];
    $[6] = collection.name;
    $[7] = setTitle;
    $[8] = t2;
    $[9] = tokenId;
    $[10] = tokenView;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  useEffect(t1, t3);
  let t4;
  if ($[12] !== router || $[13] !== tokenId) {
    t4 = newView => {
      let newPath = `/nextgen/token/${tokenId}`;
      if (newView && newView !== NextgenCollectionView.ABOUT) {
        newPath = newPath + `/${newView.toLowerCase().replaceAll(" ", "-")}`;
      }
      router.push(newPath, {
        scroll: false
      });
    };
    $[12] = router;
    $[13] = tokenId;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const updateView = t4;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NextGenNavigationHeader />;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== collection || $[17] !== token || $[18] !== tokenCount || $[19] !== tokenId || $[20] !== tokenView || $[21] !== traits || $[22] !== updateView) {
    t6 = <main className={styles.main}>{t5}{token ? <NextGenTokenComponent collection={collection} token={token} traits={traits} tokenCount={tokenCount} view={tokenView} setView={updateView} /> : <NextGenTokenOnChain collection={collection} token_id={tokenId} />}</main>;
    $[16] = collection;
    $[17] = token;
    $[18] = tokenCount;
    $[19] = tokenId;
    $[20] = tokenView;
    $[21] = traits;
    $[22] = updateView;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}